import { Command, AssertV, AddSchema, Schema, GetSchemaJSON, AssertValidate } from "mobx-firelink";
import { GetEvent } from "Store/firebase/events";
const MTName = "CharacterEntry";
AddSchema("UpdateEventCharacterEntry_payload", [MTName], () => ({
    properties: {
        eventID: { $ref: "UUID" },
        characterID: { $ref: "UUID" },
        updates: Schema({
            properties: GetSchemaJSON(MTName).properties.Including("main"),
        }),
    },
    required: ["eventID", "characterID", "updates"],
}));
//@UserEdit
export class UpdateEventCharacterEntry extends Command {
    Validate() {
        AssertValidate("UpdateEventCharacterEntry_payload", this.payload, `Payload invalid`);
        const { eventID, characterID, updates } = this.payload;
        this.oldData = GetEvent(eventID)?.characters[characterID];
        AssertV(this.oldData, "oldData is null.");
        this.newData = { ...this.oldData, ...updates };
        AssertValidate(MTName, this.newData, `New ${MTName.toLowerCase()}-data invalid`);
    }
    GetDBUpdates() {
        const { eventID, characterID } = this.payload;
        const updates = {};
        updates[`events/${eventID}/.characters/.${characterID}`] = this.newData;
        return updates;
    }
}
